export default [
  {
    name: 'Polski',
    level: 'Ojczysty',
    percent: 100,
    flag: 'https://flagcdn.com/w40/pl.png',
  },
  {
    name: 'Angielski',
    level: 'C1',
    percent: 80,
    flag: 'https://flagcdn.com/w40/us.png',
    certs: [{ level: '', link: '/certs/english-b2.pdf' }],
  },
  // {
  //   name: 'Norweski',
  //   level: 'B1+',
  //   percent: 60,
  //   flag: 'https://flagcdn.com/w40/no.png',
  // },
  // {
  //   name: 'Islandzki',
  //   level: 'B1',
  //   percent: 50,
  //   flag: 'https://flagcdn.com/w40/is.png',
  // },
  {
    name: 'Niemiecki',
    level: 'A2+',
    percent: 35,
    flag: 'https://flagcdn.com/w40/de.png',
  },
  {
    name: 'Japoński',
    level: 'A2',
    percent: 25,
    flag: 'https://flagcdn.com/w40/jp.png',
  },
  // {
  //   name: 'Chorwacki',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/hr.png',
  // },
  // {
  //   name: 'Rosyjski',
  //   level: 'A1',
  //   percent: 10,
  //   flag: 'https://flagcdn.com/w40/ru.png',
  // },
]
